export default String.raw`
.open360 {
    border-radius: 50%;
    background: #dadce0;
    color: #222222;
    font-weight: 600;
    width: 50px;
    height: 30px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 200ms;
    &:hover {
        background: #b9bac0;
        color: #000000;
    }
    &.open360-pd {
        @media screen and (max-width: 1279px) {
            padding: 20px 0;
            width: 70px;
        }
    }
}

.imageContainerPopup {
    width: fit-content !important;
    height: 80vh;
    min-height: unset;
    min-width: unset;
    overflow: unset !important;
    max-height: unset !important;
    max-width: unset !important;
    padding: 35px;
    border-radius: 12px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media screen and (max-width: 767px) {
        width: 100% !important;
        min-height: fit-content;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        max-height: 100% !important;
    }
    .close-button {
        right: -10px;
        top: -10px;
        cursor: pointer;
    }
    .img360 {
        position: relative;
        height: 100%;
        width: 100%;
        user-select: none;
        -webkit-user-select: none;
        img {
            width: auto;
            height: auto;
            display: block;
            margin: 0 auto;
            max-height: 100%;
            max-width: 100%;
            border-radius: 12px;
            user-select: none;
            -webkit-user-select: none;
        }
        .imageContainer--360btns {
            position: absolute;
            bottom: 25px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
        .imageContainer--360btn {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background-color: #dadce0;
            margin: 0 10px;
            position: relative;
            transition: 300ms;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            &:not(.btn-auto):active {
                background-color: $iconColors;
            }

            i {
                fill: #000000;
                color: #000000;
                font-size: 20px;
            }

            &.btn-active {
                background-color: $iconColors;
            }
        }
    }
}
`